import { render, staticRenderFns } from "./GroupTask.vue?vue&type=template&id=48b516be&scoped=true&lang=pug"
import script from "./GroupTask.vue?vue&type=script&lang=js"
export * from "./GroupTask.vue?vue&type=script&lang=js"
import style0 from "./GroupTask.vue?vue&type=style&index=0&id=48b516be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b516be",
  null
  
)

export default component.exports